<!-- Loading bar -->
<spri-loading-bar />

<!-- Navigation -->
<spri-vertical-navigation
  class="dark bg-indigo-800 text-white print:hidden"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.futuristic"
  [opened]="!isScreenSmall"
>
  <!-- Navigation header hook -->
  <ng-container spriVerticalNavigationHeader>
    <!-- Logo -->
    <div class="flex h-20 items-center p-6 pb-0">
      <img alt="Logo" class="w-30" [src]="tenantContextService.logoUrl() || 'images/logo/logo-text-on-dark.svg'" />
    </div>
  </ng-container>
  <!-- Navigation footer hook -->
  <ng-container spriVerticalNavigationFooter>
    <!-- User -->
    <div class="flex w-full items-center border-t px-6 py-8">
      <spri-user />
      <div class="ml-4 flex w-full flex-col overflow-hidden">
        <div class="w-full overflow-hidden text-ellipsis whitespace-nowrap leading-normal text-current opacity-80">
          {{ user.name }}
        </div>
        <div
          class="mt-0.5 w-full overflow-hidden text-ellipsis whitespace-nowrap text-sm leading-normal text-current opacity-50"
        >
          brian.hughes&#64;company.com
        </div>
      </div>
    </div>
  </ng-container>
</spri-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow md:px-6 dark:border-b dark:bg-transparent dark:shadow-none print:hidden"
  >
    <!-- Navigation toggle button -->
    <button class="mr-2" mat-icon-button (click)="toggleNavigation('mainNavigation')">
      <mat-icon [svgIcon]="'heroicons_outline:bars-3'" />
    </button>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <spri-fullscreen class="hidden md:block" />
      <spri-search [appearance]="'bar'" />
      <spri-shortcuts />
      <spri-notifications />
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet />
    }
  </div>

  <!-- Footer -->
  <div
    class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 md:px-6 dark:bg-transparent print:hidden"
  >
    <span class="text-secondary font-medium">Spri &copy; {{ tenantContextService.currentYear }}</span>
  </div>
</div>
